var abs = {
    commons: {
        locationHelpers: {
            //Format number by location (thousands and decimals)
            formatNumberByLocation: function(nNumber, nLanguage) {
                nNumber = parseFloat(nNumber).toFixed(2);
                var aAuxNumber = nNumber.split(".");
                if (nLanguage == 1 || nLanguage == 3) {
                    aAuxNumber[0] = aAuxNumber[0].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
                    return aAuxNumber[0] + "," + aAuxNumber[1];
                }
                aAuxNumber[0] = aAuxNumber[0].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                return aAuxNumber[0] + "." + aAuxNumber[1];
            },

            //Get the amount of days between the first and last date
            getDifDateDaysByLocation: function(data1, data2, nLanguage) {
                if (nLanguage == 3 || nLanguage == 1) {
                    var d1 = new Date(data1.substr(6, 4), data1.substr(3, 2) - 1, data1.substr(0, 2));
                    var d2 = new Date(data2.substr(6, 4), data2.substr(3, 2) - 1, data2.substr(0, 2));
                    return Math.ceil((d2.getTime() - d1.getTime()) / 1000 / 60 / 60 / 24);
                }

                var d1 = new Date(data1.substr(6, 4), data1.substr(0, 2) - 1, data1.substr(3, 2));
                var d2 = new Date(data2.substr(6, 4), data2.substr(0, 2) - 1, data2.substr(3, 2));
                return Math.ceil((d2.getTime() - d1.getTime()) / 1000 / 60 / 60 / 24);
            },

            //Get Date
            getDateByLocation: function(oDate) {
                if (abs.numericLanguage == 3 || abs.numericLanguage == 1) {
                    return ("0" + (oDate.getDate())).slice(-2) + "/" + ("0" + (oDate.getMonth() + 1)).slice(-2) + "/" + oDate.getFullYear();
                }

                return ("0" + (oDate.getMonth() + 1)).slice(-2) + "/" + ("0" + (oDate.getDate())).slice(-2) + "/" + oDate.getFullYear();
            }


        },
    },
    modules: {
        fnInitCowCardDropdown: function() {
            $("#cow_search").select2({
                placeholder: abs.lang.template.header.cow.card,
                dropdownAutoWidth: true,
                language: abs.jsLocale,
                tokenSeparators: [
                    ',',
                    ' '
                ],
                minimumInputLength: 1,
                theme: "bootstrap",
                ajax: {
                    url: "/api/getCowByName",
                    cache: true,
                    dataType: "JSON",
                    delay: 250,
                    data: function(params) {
                        var query = {
                            q: params.term,
                            herdId: abs.herdId
                        }
                        return query;
                    },
                    processResults: function(oResponse) {
                        if (oResponse.isOperationSuccess && oResponse.data.length) {

                            var iLength = oResponse.data.length;
                            var aoData = [];
                            for (var i = 0; i < iLength; i++) {
                                aoData.push({
                                    "id": oResponse.data[i].id + "|" + oResponse.data[i].herdId,
                                    "text": oResponse.data[i].name
                                });
                            }
                            return {
                                results: aoData
                            };
                        }
                        return {
                            results: []
                        };

                    }
                }
            });
            $("#cow_search").on("change", function() {
                var aSplit = $(this).val().split("|");
                var sParams = "?id=" + aSplit[1] + "&cow=" + aSplit[0];

                window.location = abs.baseUrl + "/cow-card" + sParams;
            });
        },
        fnOpenTicket: function() {
            $("#open_ticket").on("click", function() {
                $.ajax({
                    url: "/api/ticket-form?id=" + abs.herdId + "&title=" + $("title").html(),
                    async: true,
                    xhrFields: { withCredentials: true },
                    success: function(response) {
                        var viewportWidth = $(window).width();
                        var viewportHeight = $(window).height();


                        $("#ticket_dialog").dialog({
                            width: (
                                900
                            ),
                            height: (
                                610
                            ),
                            title: abs.lang.all.report_problem,
                            modal: true,
                            autoOpen: false,
                            open: function(event, ui) {
                                //$(".ui-dialog-titlebar-close", ui.dialog | ui).hide();
                                $("#ticket_dialog").html(response);

                                $("#ticket_dialog").find("form").on("submit", abs.utils.fnUploadTicketAjax)
                                    .append($("<input name='subject' type='hidden'>").val($("title").html()));
                            },
                            /*buttons  : [
                             {
                             //disabled : true,
                             text  : "close",
                             id    : "",
                             click : function ()
                             {
                             var $this = $(this);
                             $this.dialog("close");
                             }
                             }
                             ]*/
                        });
                        $("#ticket_dialog").dialog("open");
                    }
                });
            });
        },

        fnInitLanguageMenu: function(sUrl, sBaseUrl, sCurrentLocale) {
            $("#language_menu").val(sCurrentLocale);
            $("#language_menu").on("change", function() {
                $.ajax({
                    url: sBaseUrl + "/api/locale",
                    data: { "locale": $(this).val() },
                    dataType: "json",
                    type: "POST",
                    async: true,
                    xhrFields: { withCredentials: true },
                    success: function(response) {
                        if (response.isOperationSuccess) {
                            window.location = sUrl.replace(/&amp;/g, '&');
                        }
                    }
                });
            });
        },
        fnInitUsersDropdown: function() {

            $.ajax({
                url: abs.baseUrl + "/api/users/fetchUsersByTechnician",
                dataType: "json",
                async: true,
                xhrFields: { withCredentials: true },
                success: function(response) {
                    if (typeof response.isOperationSuccess != "undefined" && response.isOperationSuccess) {
                        var nUsers = response.user.length;
                        var $select = $("#dropdown_users").find("select");
                        for (var i = 0; i < nUsers; i++) {
                            if (response.user[i].lastHerdId) {
                                var sSelected = "";
                                var sDate = "";
                                if (response.user[i].lastHerdId == abs.herdId) {
                                    sSelected = "selected";
                                }
                                if (response.user[i].lastABSFileUpdate) {
                                    sDate = response.user[i].lastABSFileUpdate;
                                }
                                $select.append("<option value='" + response.user[i].lastHerdId + "|" + response.user[i].id + "' " + sSelected +
                                    "><strong>" + sDate + "</strong> - " + response.user[i].name + " (" +
                                    response.user[i].farmName + ")" + "</option>"
                                );
                            }
                        }

                        $select.on("change", function() {

                            var aSplit = $(this).val().split("|");
                            if (abs.currentUrlNoParams.indexOf("calculators/") >= 0) {

                                abs.modules.fnInitCalculatorsAndExpireDate(aSplit[0], function() {
                                    var aUrlSplit = abs.currentUrlNoParams.split("/");
                                    var sElement = aUrlSplit[aUrlSplit.length - 1];
                                    window.location = $("#" + sElement).attr("href");
                                });
                                return;

                            }

                            var sParams = "?id=" + aSplit[0];
                            if (abs.currentUrl.indexOf("user_id") != -1) {
                                sParams += "&user_id=" + aSplit[1];
                            }
                            window.location = abs.currentUrlNoParams + sParams;
                        });
                        abs.utils.fnInitSelect2($select);
                        $("#dropdown_users_loader").hide();
                        $select.show();
                    }
                }
            });
        },
        fnInitCalculatorsAndExpireDate: function(nHerdId, fnCallback) {
            if (typeof nHerdId == "undefined") {
                nHerdId = abs.herdId;
            }
            $.ajax({
                url: abs.baseUrl + "/api/calculators/rest/" + nHerdId,
                dataType: "json",
                async: true,
                xhrFields: { withCredentials: true },
                success: function(response) {
                    if (response.isOperationSuccess) {
                        var oDimImpact = {
                            "id": nHerdId,
                            "customer": response.data.users.name,
                            "atual": response.data.managementParameters.dimAvg ? response.data.managementParameters.dimAvg : 0,
                            "meta": response.data.managementParameters.desiredDimAvg ? response.data.managementParameters.desiredDimAvg : 0,
                            "payment": response.data.managementParameters.paymentSystem ? response.data.managementParameters.paymentSystem : "KG",
                            "pdp": response.data.managementParameters.peakDailyProduction ? response.data.managementParameters.peakDailyProduction : 0,
                            "raca": response.data.managementParameters.geneticComposition ? response.data.managementParameters.geneticComposition : "ZEBU",
                            "pdl": response.data.managementParameters.milkPrice ? response.data.managementParameters.milkPrice : 0,
                            "ntv": response.data.managementParameters.cowsQty ? response.data.managementParameters.cowsQty : 0,
                        };
                        var oLocomotion = {
                            "id": nHerdId,
                            "customer": response.data.users.name,
                            "unity": response.data.managementParameters.paymentSystem ? response.data.managementParameters.paymentSystem : "KG",
                            "avarage_milk_production": response.data.managementParameters.milkProductionAvg ? response.data.managementParameters.milkProductionAvg : "0",
                            "base_price": response.data.managementParameters.milkPrice ? response.data.managementParameters.milkPrice : 0,
                            "total_cows_herd": response.data.managementParameters.cowsQty ? response.data.managementParameters.cowsQty : 0,
                        };

                        var oCowConfort = {
                            "id": nHerdId,
                            "customer": response.data.users.name,
                            "farm_name": response.data.users.farmName,
                            "unity": response.data.managementParameters.paymentSystem ? response.data.managementParameters.paymentSystem : "KG",
                            "base_price": response.data.managementParameters.milkPrice ? response.data.managementParameters.milkPrice : 0
                        };
                        var sQueryString = "?";
                        $("#dim_impact").attr("href", abs.baseUrl + "/calculators/dim_impact" + sQueryString + $.param(oDimImpact));
                        $("#locomotion").attr("href", abs.baseUrl + "/calculators/locomotion" + sQueryString + $.param(oLocomotion));
                        $("#cow_comfort").attr("href", abs.baseUrl + "/calculators/cow_comfort" + sQueryString + $.param(oCowConfort));
                        $("#thi").attr("href", abs.baseUrl + "/calculators/thi" + sQueryString + $.param(oCowConfort));
                        $("#pregnancy_insemination_hardcount").attr("href", abs.baseUrl + "/calculators/pregnancy_insemination_hardcount" +
                            sQueryString + $.param(oCowConfort)
                        );
                        $("#comparative_conception_rate_calculator").attr("href", abs.baseUrl +
                            "/calculators/comparative_conception_rate_calculator" +
                            sQueryString + $.param(oCowConfort)
                        );


                        if (typeof fnCallback !== "undefined") {
                            fnCallback();
                        }
                    }
                }
            });
            $.ajax({
                url: abs.baseUrl + "/api/fetchUserExpireById",
                dataType: "json",
                data: {
                    user_id: abs.userId,
                    locale: abs.locale
                },
                async: true,
                xhrFields: { withCredentials: true },
                success: function(oResponse) {
                    if (oResponse) {

                        if (!oResponse.isOperationSuccess) {
                            alert(oResponse.messages.message);
                            window.location = abs.oldBaseUrl;
                        }
                        var $expireBlock = $("#expire_user_block");
                        $expireBlock.find("#expire_user_message").text(oResponse.messages.message);
                        $expireBlock.find("#expire_user_days_message").text(oResponse.messages.day);
                        $expireBlock.find("#expire_user_date_days").text(oResponse.date_days);
                        $expireBlock.find("#expire_user_date").text(oResponse.user.expire);

                        $expireBlock.find("#expire_user_date_days").css({ color: "blue" });
                        $expireBlock.find("#expire_user_date").css({ color: "blue" });
                        $expireBlock.find("img").attr({
                            "src": abs.baseUrl + "/images/common/icon_key.png",
                            "height": "12"
                        }).css({ "height": "12px" });

                        if (oResponse.date_days <= 30) {
                            $expireBlock.find("img").attr({
                                "src": abs.baseUrl + "/images/common/redwarningicon.png",
                                "height": "12"
                            });
                            $expireBlock.find("#expire_user_date_days").css({
                                color: "red",
                                "font-weight": "bold"
                            });
                            $expireBlock.find("#expire_user_date").css({
                                color: "red",
                                "font-weight": "bold"
                            });
                        }
                        $("#expire_users_loader").remove();
                        $expireBlock.show();

                        var url = window.location.href,
                            substring = "dashboard";

                        if (oResponse.date_days <= 30 && url.includes(substring)) {
                            abs.utils.fnShowAccountExpirationMessage(oResponse.date_days);
                        }
                    }

                }
            });
        }
    },
    utils: {

        fnFormatDecimals: function(nNumeric, nDecimals) {
            if (typeof nDecimals == "undefined") {
                nDecimals = 1;
            }
            if (!isNaN(nNumeric)) {
                nNumeric = parseFloat(nNumeric);
            }
            return $.fn.dataTable.render.number(abs.number.thousand, abs.number.decimal, nDecimals, '').display(nNumeric);
        },
        fnValidateEmail: function(emailAddress) {
            var sQtext = '[^\\x0d\\x22\\x5c\\x80-\\xff]';
            var sDtext = '[^\\x0d\\x5b-\\x5d\\x80-\\xff]';
            var sAtom = '[^\\x00-\\x20\\x22\\x28\\x29\\x2c\\x2e\\x3a-\\x3c\\x3e\\x40\\x5b-\\x5d\\x7f-\\xff]+';
            var sQuotedPair = '\\x5c[\\x00-\\x7f]';
            var sDomainLiteral = '\\x5b(' + sDtext + '|' + sQuotedPair + ')*\\x5d';
            var sQuotedString = '\\x22(' + sQtext + '|' + sQuotedPair + ')*\\x22';
            var sDomain_ref = sAtom;
            var sSubDomain = '(' + sDomain_ref + '|' + sDomainLiteral + ')';
            var sWord = '(' + sAtom + '|' + sQuotedString + ')';
            var sDomain = sSubDomain + '(\\x2e' + sSubDomain + ')*';
            var sLocalPart = sWord + '(\\x2e' + sWord + ')*';
            var sAddrSpec = sLocalPart + '\\x40' + sDomain; // complete RFC822 email address spec
            var sValidEmail = '^' + sAddrSpec + '$'; // as whole string

            var reValidEmail = new RegExp(sValidEmail);

            return reValidEmail.test(emailAddress);
        },
        fnUploadTicketAjax: function(e) {

            if (!abs.utils.fnValidateEmail($this.find("#email").val()) ||
                (
                    $this.find("#phone").val() == "" || $this.find("#phone").val() == null
                ) ||
                (
                    $this.find("#message_ticket").val() == "" || $this.find("#message_ticket").val() == null
                )) {
                return false;
            }
            e.preventDefault();
            var formData = new FormData($(this)[0]);
            $.ajax({
                url: '/api/ticket?id=' + abs.herdId,
                type: 'POST',
                data: formData,
                contentType: false,
                processData: false,
                cache: false,
                "headers": {
                    "userid": abs.userId,
                },
                xhrFields: { withCredentials: true },
                success: function(oData) {
                    if (typeof oData != "undefined" && oData.isOperationSuccess) {

                        $("#ticket_dialog").dialog("close");
                        alert(abs.lang.all.message_sent);
                        return;

                    }
                    var sMessage = oData.messages.message;
                    alert(sMessage);
                    $("#ticket_dialog").dialog("close");
                }
            });
        },

        fnGetLight: function(sLight) {
            var oLights = {
                "above_interval": "/images/common/conditional_green.gif",
                "between_interval": "/images/common/conditional_yellow.gif",
                "below_interval": "/images/common/conditional_red.gif",
                "critical_below_interval": "/images/common/conditional_critical_below.png",
                "between_below_interval": "/images/common/between_below_interval.png"
            };

            if (sLight) {

                return oLights[sLight];
            }
            return false;
        },

        fnCapitalizeWords: function(str) {
            return str.replace(/(^|\s)[a-z\u00E0-\u00FC]/g, function(txt) {
                return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
            });
        },

        //This method add binary option to ajax, used to force download pdf/xls on JS. Works only on modern browsers
        fnBinaryOptionOnJquery: function(j) {
            j.ajaxTransport("+binary", function(options, originalOptions, jqXHR) {
                // check for conditions and support for blob / arraybuffer response type
                if (window.FormData && (
                        (
                            options.dataType && (
                                options.dataType == 'binary'
                            )
                        ) || (
                            options.data && (
                                (
                                    window.ArrayBuffer && options.data instanceof ArrayBuffer
                                ) || (
                                    window.Blob && options.data instanceof Blob
                                )
                            )
                        )
                    )) {
                    return {
                        // create new XMLHttpRequest
                        send: function(headers, callback) {
                            // setup all variables
                            var xhr = new XMLHttpRequest(),
                                url = options.url,
                                type = options.type,
                                async = options.async || true,
                                // blob or arraybuffer. Default is blob
                                dataType = options.responseType || "blob",
                                data = options.data || null,
                                username = options.username || null,
                                password = options.password || null;

                            xhr.addEventListener('load', function() {
                                var data = {};
                                data[options.dataType] = xhr.response;
                                // make callback and send data
                                callback(xhr.status, xhr.statusText, data, xhr.getAllResponseHeaders());
                            });

                            xhr.open(type, url, async, username, password);

                            // setup custom headers
                            for (var i in headers) {
                                xhr.setRequestHeader(i, headers[i]);
                            }

                            xhr.responseType = dataType;
                            xhr.send(data);
                        },
                        abort: function() {
                            jqXHR.abort();
                        }
                    };
                }
            });
        },


        fnInitSelect2: function($element) {
            var fnFormatDropdown = function(state) {
                if (!state.id) {
                    return state.text;
                }
                var $state = $(
                    '<div style="width: 100%;"><span style="width: 50%; display: inline-block">' + state.text +
                    '</span><span style="width: 50%; display: inline-block; text-align: right;">bbb</span></div>'
                );
                var $state = $(
                    '<div style="width: 100%;"><span style="width: 50%; display: inline-block">' + state.text +
                    '</span><span style="width: 50%; display: inline-block; text-align: right;">bbb</span></div>'
                );
                return $state;
            };
            $element.select2({
                theme: "bootstrap",
                //templateResult : fnFormatDropdown,
                dropdownAutoWidth: true,
            });
        },

        fnForceDownloadAjax: function(sUrl, oData, sFileName) {
            $.ajax({
                type: "POST",
                dataType: "binary",
                url: sUrl,
                data: oData,
                cache: false,
                success: function(response, status, xhr) {
                    // check for a filename
                    var filename = sFileName;
                    var disposition = "attachment";
                    //var disposition = xhr.getResponseHeader('Content-Disposition');
                    if (disposition && disposition.indexOf('attachment') !== -1) {
                        var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                        var matches = filenameRegex.exec(disposition);
                        if (matches != null && matches[1]) {
                            filename = matches[1].replace(/['"]/g, '');
                        }
                    }

                    var type = xhr.getResponseHeader('Content-Type');
                    var blob = new Blob([response], { type: type });

                    if (typeof window.navigator.msSaveBlob !== 'undefined') {
                        // IE workaround for "HTML7007: One or more blob URLs were revoked by closing the blob for which they were created. These URLs will no longer resolve as the data backing the URL has been freed."
                        window.navigator.msSaveBlob(blob, filename);
                    } else {
                        var URL = window.URL || window.webkitURL;
                        var downloadUrl = URL.createObjectURL(blob);

                        if (filename) {
                            // use HTML5 a[download] attribute to specify filename
                            var a = document.createElement("a");
                            // safari doesn't support this yet
                            if (typeof a.download === 'undefined') {
                                window.location = downloadUrl;
                            } else {
                                a.href = downloadUrl;
                                a.download = filename;
                                document.body.appendChild(a);
                                a.click();
                            }
                        } else {
                            window.location = downloadUrl;
                        }

                        setTimeout(function() {
                            URL.revokeObjectURL(downloadUrl);
                        }, 100); // cleanup
                    }
                }
            });
        },
        fnShowAccountExpirationMessage: function(sExpDays) {

            $("<div id='dialog-confirm222' style='font-size:13px;'>").html("Sua senha de acesso irá expirar em " + sExpDays + " dias, entre em contato com o Representante ABS para providenciar a renovação de sua assinatura e garanta mais um ano de uso").appendTo($("body"));
            $("#dialog-confirm222").dialog({
                resizable: false,
                width: 500,
                height: 200,
                closeOnEscape: false,
                title: "ABS Monitor: Contas",
                modal: true,
                create: function(e, ui) {


                },
                buttons: [{
                    disabled: false,
                    text: "Ok",
                    id: "account_expiration_button",
                    click: function() {
                        $("#dialog-confirm222").dialog("close");
                    }
                }],
                open: function(event, ui) {

                    var pane = $(this).dialog("widget").find(".ui-dialog-buttonpane");
                    $("#dialog-confirm222").prev().css({ "background-color": "red" });

                    $("body").css({
                        overflow: 'hidden'
                    });
                    $(".ui-widget-overlay").css({
                        background: "#000",
                        opacity: "1 !important",
                        filter: "Alpha(Opacity=1)",
                    });


                    $(".ui-dialog-titlebar-close", ui.dialog | ui).hide();

                },
                beforeClose: function(event, ui) {
                    $("body").css({ overflow: 'inherit' })
                }
            });
        },
        fnShowVideoDialog: function(psCookieName, psVideoName) {

            $("#video_dialog").html('<video width="850" height="540" controls controlsList="nodownload" preload="auto">\n' +
                '            <source src="/videos/' + psVideoName + '.mp4" type="video/mp4" />\n' +
                '            <source src="/videos/' + psVideoName + '.ogv" type="video/ogg" />\n' +
                '            <source src="/videos/' + psVideoName + '.webm" type="video/webm" />\n' +
                '            Your browser does not support HTML5 video.\n' +
                '        </video>').dialog({
                width: (
                    900
                ),
                height: (
                    670
                ),
                position: { my: "center center", at: "center center", of: window },
                title: "ABS TV",
                modal: true,
                autoOpen: true,
                resizable: false,
                buttons: {
                    Ok: function() {
                        $(this).dialog("close");
                    }
                },
                beforeClose: function(event, ui) {
                    Cookies.set(psCookieName, "1");
                }

            });
        }
    },
};